(function () {
  'use strict';

  /*
   * ==========================================================
   * INGREDIENT STORY
   * ==========================================================
   *
   * This JS is intentionally scoped to:
   *
   * .ingredient-story[data-section-id]
   *
   * so multiple instances of the section can exist on the
   * same page without interfering with each other.
   *
   * No functionality or behavior has been changed.
   */


  /*
   * ==========================================================
   * FIND ALL INGREDIENT STORY SECTIONS
   * ==========================================================
   */

  const sections = document.querySelectorAll(
    '.ingredient-story[data-section-id]'
  );

  if (!sections.length) return;


  /*
   * ==========================================================
   * INITIALIZE EACH SECTION
   * ==========================================================
   */

  sections.forEach(function (section) {


    /* ========================================================
       TAB SWITCHING
       ======================================================== */

    const tabs = section.querySelectorAll('[data-story-tab]');
    const panels = section.querySelectorAll('[data-story-panel]');


    function activateTab(tabName) {

      tabs.forEach(function (tab) {

        const isActive =
          tab.dataset.storyTab === tabName;

        tab.classList.toggle(
          'is-active',
          isActive
        );

        tab.setAttribute(
          'aria-selected',
          isActive ? 'true' : 'false'
        );

      });


      panels.forEach(function (panel) {

        const isActive =
          panel.dataset.storyPanel === tabName;

        panel.classList.toggle(
          'is-active',
          isActive
        );

        if (isActive) {

          panel.removeAttribute('hidden');

        } else {

          panel.setAttribute('hidden', '');

        }

      });


      /*
       * Reinitialize the active media after switching tabs.
       */

      const activePanel = section.querySelector(
        '[data-story-panel="' + tabName + '"]'
      );

      if (!activePanel) return;


      const firstIngredient =
        activePanel.querySelector(
          '.ingredient-story__ingredient'
        );


      if (firstIngredient) {

        setActiveIngredient(
          activePanel,
          parseInt(
            firstIngredient.dataset.ingredientIndex,
            10
          )
        );

      }

    }


    tabs.forEach(function (tab) {

      tab.addEventListener(
        'click',
        function () {

          activateTab(
            tab.dataset.storyTab
          );

        }
      );

    });


    /* ========================================================
       MEDIA / INGREDIENT SYNC
       ======================================================== */

    function setActiveIngredient(panel, index) {

      if (!panel || Number.isNaN(index)) return;


      const ingredients =
        panel.querySelectorAll(
          '.ingredient-story__ingredient'
        );


      const mediaItems =
        panel.querySelectorAll(
          '.ingredient-story__media-item'
        );


      ingredients.forEach(function (ingredient) {

        const ingredientIndex =
          parseInt(
            ingredient.dataset.ingredientIndex,
            10
          );


        ingredient.classList.toggle(
          'is-active',
          ingredientIndex === index
        );

      });


      mediaItems.forEach(function (media) {

        const mediaIndex =
          parseInt(
            media.dataset.mediaIndex,
            10
          );


        const active =
          mediaIndex === index;


        media.classList.toggle(
          'is-active',
          active
        );


        /*
         * Pause inactive videos.
         * Play active video.
         */

        const video =
          media.querySelector('video');


        if (video) {

          if (active) {

            const playPromise =
              video.play();


            if (playPromise !== undefined) {

              playPromise.catch(
                function () {}
              );

            }

          } else {

            video.pause();

          }

        }

      });

    }


    /* ========================================================
       CLICK / TAP
       ======================================================== */

    panels.forEach(function (panel) {

      const ingredients =
        panel.querySelectorAll(
          '.ingredient-story__ingredient'
        );


      ingredients.forEach(function (ingredient) {

        const button =
          ingredient.querySelector(
            '.ingredient-story__ingredient-button'
          );


        if (!button) return;


        button.addEventListener(
          'click',
          function () {

            const index =
              parseInt(
                ingredient.dataset.ingredientIndex,
                10
              );


            setActiveIngredient(
              panel,
              index
            );

          }
        );


        /*
         * Keyboard accessibility.
         */

        ingredient.addEventListener(
          'keydown',
          function (event) {

            if (
              event.key === 'Enter' ||
              event.key === ' '
            ) {

              event.preventDefault();


              const index =
                parseInt(
                  ingredient.dataset.ingredientIndex,
                  10
                );


              setActiveIngredient(
                panel,
                index
              );

            }

          }
        );

      });

    });


    /* ========================================================
       DESKTOP SCROLL BEHAVIOUR
       ========================================================

       Your original IntersectionObserver code was commented
       out, so it remains commented out here.

    */

    /*
    function initScrollObserver(panel) {

      const ingredients = panel.querySelectorAll(
        '.ingredient-story__ingredient'
      );

      if (!ingredients.length) return;


      const desktopQuery =
        window.matchMedia('(min-width: 750px)');


      let observer = null;


      function createObserver() {

        if (observer) {

          observer.disconnect();
          observer = null;

        }


        if (!desktopQuery.matches) return;


        observer = new IntersectionObserver(

          function (entries) {

            let bestEntry = null;
            let smallestDistance = Infinity;


            entries.forEach(function (entry) {

              if (!entry.isIntersecting) return;


              const rect =
                entry.target.getBoundingClientRect();


              const elementCenter =
                rect.top + (rect.height / 2);


              const viewportCenter =
                window.innerHeight / 2;


              const distance =
                Math.abs(
                  elementCenter - viewportCenter
                );


              if (distance < smallestDistance) {

                smallestDistance = distance;
                bestEntry = entry;

              }

            });


            if (bestEntry) {

              const index =
                parseInt(
                  bestEntry.target.dataset.ingredientIndex,
                  10
                );


              setActiveIngredient(
                panel,
                index
              );

            }

          },

          {
            root: null,
            rootMargin: '-38% 0px -38% 0px',
            threshold: [
              0,
              0.1,
              0.25,
              0.5,
              0.75,
              1
            ]
          }

        );


        ingredients.forEach(function (ingredient) {

          observer.observe(ingredient);

        });

      }


      createObserver();


      desktopQuery.addEventListener(
        'change',
        createObserver
      );

    }


    panels.forEach(function (panel) {

      initScrollObserver(panel);

    });
    */


    /* ========================================================
       FULL INGREDIENT LIST
       ======================================================== */

    const fullListButtons =
      section.querySelectorAll(
        '[data-full-list-toggle]'
      );


    fullListButtons.forEach(function (button) {

      button.addEventListener(
        'click',
        function () {

          const type =
            button.dataset.fullListToggle;


          const content =
            section.querySelector(
              '[data-full-list-content="' +
              type +
              '"]'
            );


          if (!content) return;


          const open =
            content.classList.toggle(
              'is-open'
            );


          button.setAttribute(
            'aria-expanded',
            open ? 'true' : 'false'
          );

        }
      );

    });


    /* ========================================================
       INITIAL STATE
       ======================================================== */

    const initialPanel =
      section.querySelector(
        '[data-story-panel="science"]'
      );


    if (initialPanel) {

      const firstIngredient =
        initialPanel.querySelector(
          '.ingredient-story__ingredient'
        );


      if (firstIngredient) {

        setActiveIngredient(
          initialPanel,
          parseInt(
            firstIngredient.dataset.ingredientIndex,
            10
          )
        );

      }

    }

  });

})();
